export const PAYSTACK_URL = 'https://js.paystack.co/v1/inline.js';
export const PAYSTACK_KEY = {
  development: 'pk_test_9738da7aa0ad120d07ee4083e19f5156f7a6fa64',
  production: 'pk_live_d368608beaa75e56300be2c7fbc5fe8f6f7d6eb4',
};
export const PAYPAL_URL = {
  development: 'https://www.paypal.com/sdk/js?client-id=AdwX-5yebmCzLyi4rJ0GvyAKhP8u0bjlplnoHbT3hjJZCfZq8FFsNtsSkMS1l84eiAqTG2tSDvpxFOY9&currency=GBP',
  production: 'https://www.paypal.com/sdk/js?client-id=AQT8St_hnnGCXG2EbN35hRCl2f7CZ0Y0am-WnKFzO9UE5CJN-NgSDBoGa6hX9wWRN2yGvy2MMdr0PVyG&currency=GBP',
};
